var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hotel"}},[_c('FirstFrame'),_c('div',{staticClass:"container frame"},[_c('AboutFrame'),_c('PriceFrame'),_c('GalleryFrame'),_c('ContactFrame'),_c('ReviewsFrame'),_c('QuadroFrame')],1),_c('FooterFrame')],1)}
var staticRenderFns = []

export { render, staticRenderFns }